// @vendors
const React = require('react');
const moment = require('moment');

// @commons
const listItem = require('./listItem');
const { text } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestViewProcess/initialValues');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { formatText } = require('core/i18n').i18n;

// @constants
const MORTGAGE_STATES = require('constants/mortgageRequestStates');


const checkStatus = (item, state) => {
    const textValue = text();
    if (item === textValue.SECTION.SIGNATURE_PREPARATION.EXPENSES) {
        if (state === MORTGAGE_STATES.PEND_FIRMA || state === MORTGAGE_STATES.FIRMADO) {
            return true;
        }
    }

    if (item === textValue.SECTION.SIGNATURE_PREPARATION.SIGNATURE) {
        if (state === MORTGAGE_STATES.FIRMADO) {
            return true;
        }
    }

    return false;
};

const buildTargetDate = date => {
    if (moment(date, 'YYYY-MM-DD').isValid()) {
        const dateFormatted = moment(date).format('DD/MM/YY');
        return (
            <div className="mortgage-request-view-process__panel-left-target-date">
                <strong>{formatText('mortgageRequestPanel-dataProprietorDataTarget')}: {dateFormatted}</strong>
            </div>
        );
    } else {
        return '';
    }
};

const sectionSignaturePreparation = data => {
    const textValue = text();
    const targetDate = data.get('fechaObjetivo')
        ? buildTargetDate(data.get('fechaObjetivo'))
        : null;

    const list = data.get('isFetching')
        ? <LoadingSection />
        : (<div>
            {listItem(
                textValue.SECTION.SIGNATURE_PREPARATION.ITEM_EXPENSES,
                checkStatus(textValue.SECTION.SIGNATURE_PREPARATION.EXPENSES, data.get('estado'))
            )}
            {listItem(
                textValue.SECTION.SIGNATURE_PREPARATION.ITEM_PREPARATION,
                checkStatus(textValue.SECTION.SIGNATURE_PREPARATION.SIGNATURE, data.get('estado'))
            )}
        </div>);

    return (
        <div className="mortgage-request-view-process__panel-left-section">
            <OKBoxTitle value={textValue.SECTION.SIGNATURE_PREPARATION.TITLE} size="medium" />
            {list}
            {targetDate}
        </div>
    );
};

module.exports = sectionSignaturePreparation;
